import React from 'react'

const IconAdd = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1H16C20.1421 1 23.5 4.35786 23.5 8.5V16.5C23.5 20.6421 20.1421 24 16 24H8C3.85786 24 0.5 20.6421 0.5 16.5V8.5C0.5 4.35786 3.85786 1 8 1Z"
        stroke={'#e2e2fc'}
      />
      <path
        d="M7 12.5H17"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M12 17.5V7.5"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default IconAdd
